<template>
  <div>
    <ReactWrapper :component="SequenceResultsComponent" :props="props" />
  </div>
</template>

<script>
  import { SequenceResults as SequenceResultsComponent } from '../../../../../frontendV2/dist/reactComponents';
  import ReactWrapper from '@/components/blocks/reactComponents/ReactWrapper';

  export default {
    name: 'SequenceResults',

    components: {
      ReactWrapper,
    },

    data: () => ({
      SequenceResultsComponent,
    }),

    props: {
      sequenceId: {
        type: Number,
        required: true,
      },
    },

    computed: {
      props() {
        return {
          sequenceId: this.sequenceId,
          onShowInjection: this.handleShowInjection,
          onShowReportGenerator: this.onShowReportGenerator,
        };
      },
    },

    methods: {
      handleShowInjection(payload) {
        this.$emit('showInjection', payload);
      },
      onShowReportGenerator() {
        this.$emit('showReportGenerator');
      },
    },
  };
</script>
